// Only add common function that required for API

import { getCookie } from '../shared-functions/Cookies';

/**
 * Function to get auth token from cookie
 */
const getEventControlKey = () => {
  const accessToken = getCookie('ev-access-token');
  if (accessToken) {
    return accessToken;
  }
  return null;
};

/**
 * Function to get auth token from cookie
 */
const getToken = () => {
  const accessToken = getEventControlKey();
  if (accessToken) {
    return accessToken;
  }
  return null;
};

// Change when adding new functions
export default getToken;
